import React from 'react';
import { connect } from 'react-redux';

const CommonAvatar = ({ className, label, ...props }) => (
  <span className={`common-avatar ${className ? className : ''}`} {...props}>
    {label}
  </span>
);

const UserAvatarComponent = ({ className, userInfo, isLogin, ...props }) => {
  // Don't render if not logged in
  if (!isLogin) {
    return null;
  }

  // Don't render if no userInfo
  if (!userInfo || Object.keys(userInfo).length === 0) {
    return null;
  }

  const { given_name = 'Unknown', family_name = 'User', isClient } = userInfo;
  const nameLabel = (given_name[0] || 'U') + (family_name[0] || 'U');

  return (
    <CommonAvatar
      {...props}
      className={`user-avatar ${className ? className : ''} ${
        isClient ? 'client' : 'internal'
      }`}
      label={nameLabel}
    />
  );
};

// Connect to Redux to get login status
export const UserAvatar = connect((state) => ({
  isLogin: state.login.isLogin,
}))(UserAvatarComponent);

export default CommonAvatar;
